import { Flex, Typography } from 'antd'

import type { FlexProps } from 'antd'
import type { BaseType } from 'antd/es/typography/Base'

const { Text } = Typography

interface DescriptionLabelProps extends Omit<FlexProps, 'children'> {
  label: string
  info?: string | number
  labelType?: BaseType
}

export const DescriptionLabel = ({
  label,
  info,
  labelType = 'secondary',
  ...props
}: DescriptionLabelProps) => {
  return (
    <Flex {...props}>
      <Text type={labelType}>{label}</Text>
      <Text strong>{info || '---'}</Text>
    </Flex>
  )
}
